<template>
  <div
    class="modal fade"
    :id="ID"
    :data-bs-backdrop="isStatic && isStatic === true ? 'static' : null"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      :class="size"
    >
      <div class="modal-content" :class="modalClass">
        <div class="modal-header" :class="modalHeaderClass">
          <slot name="header">
            <!-- default Value -->
            <h5 class="modal-title">پیام</h5>
          </slot>
          <button
            v-if="showCloseButton"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body" :class="modalBodyClass">
          <slot name="body">
            <!-- main required -->
          </slot>
        </div>
        <div
          class="modal-footer"
          :class="modalFooterClass"
          v-if="modalHasFooter"
        >
          <slot name="footer">
            <!-- default Value -->
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="$emit('confirm')"
            >
              تایید
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ID: {
      type: String,
      required: true,
    },
    modalHasFooter: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    isStatic: {
      type: Boolean,
      required: false,
      default: false,
    },
    modalSize: {
      type: String,
      required: false,
      default: 'modal',
    },
    modalClass: {
      type: String,
      required: false,
      default: '',
    },
    modalHeaderClass: {
      type: String,
      required: false,
      default: '',
    },
    modalFooterClass: {
      type: String,
      required: false,
      default: '',
    },
    modalBodyClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    size() {
      return this.modalSize == 'small'
        ? 'modal-sm'
        : this.modalSize == 'semiMedium'
        ? ''
        : this.modalSize == 'medium'
        ? 'modal-lg'
        : this.modalSize == 'large'
        ? 'modal-xl'
        : '';
    },
  },
  emits: ['beforeShow', 'showed', 'beforeClose', 'closed', 'confirm'],
  methods: {
    closeModal(e) {
      this.$emit('closed', e);
    },
  },
  mounted() {
    var myModalEl = document.getElementById(this.ID);
    myModalEl.addEventListener(
      'show.bs.modal',
      function (e) {
        this.$emit('beforeShow', e);
      }.bind(this)
    );
    myModalEl.addEventListener(
      'shown.bs.modal',
      function (e) {
        this.$emit('showed', e);
        // focus
        if (
          document.querySelectorAll('.form-select')[0] &&
          !document.getElementById('centerModal')
        ) {
          document.querySelectorAll('.form-select')[0].focus();
        } else if (document.querySelectorAll('.form-control')[0]) {
          document.querySelectorAll('.form-control')[0].focus();
        }
      }.bind(this)
    );
    myModalEl.addEventListener(
      'hide.bs.modal',
      function (e) {
        this.$emit('beforeClose', e);
      }.bind(this)
    );

    myModalEl.addEventListener(
      'hidden.bs.modal',
      function (e) {
        this.$emit('closed', e);
      }.bind(this)
    );
  },
};
</script>

<style scoped>
* {
  border-color: rgba(0, 0, 0, 0.2);
}
.modal-header .btn-close {
  filter: invert(72%) sepia(49%) saturate(589%) hue-rotate(356deg)
    brightness(104%) contrast(95%) !important;
}
.btn-close:focus {
  filter: invert(72%) sepia(49%) saturate(589%) hue-rotate(356deg)
    brightness(104%) contrast(95%) !important;
}
.modal-header {
  color: #f9c641 !important;
  background-color: #506690 !important;
}
.modal-content {
  border-radius: 10px;
}
</style>
